<script setup lang="ts">
import type { BlogPost } from "@/schemas/blog";

defineProps<{ posts: BlogPost[] }>();
</script>

<template>
  <UiEmptyResult v-if="!posts.length" title="Aucun article à afficher" />
  <div v-else class="space-y-12">
    <BlogPostListItem v-for="post in posts" :key="post.post_id" :post="post" />
  </div>
</template>
